/**
 * Regular CTA boxes with one product option and one-time/subscribe
 * name = product
 * */
// Update names of sections to have separate names
function updateProductNames() {
    const tables = document.querySelectorAll('.js-table');
    if(!tables.length) return;

    tables.forEach((table, index) => {
        if(table.querySelectorAll('[name=product]').length) {
            table.querySelectorAll('[name=product]').forEach(item => {
                item.setAttribute("name", `product-${index}`);

                if(item.checked) { updatePricesEverywhere(item); }

                item.addEventListener('change', updatePrices)
            })
        }
    });
}
updateProductNames();

// Update the prices for the regular CTA in all sections
function updatePrices(event) {
    updatePricesEverywhere(event.target);
}

// Update the prices for the regular CTA in all sections
function updatePricesEverywhere(target) {
    const value = target.value;
    const price = target.dataset.price;

    const tables = document.querySelectorAll('.js-table');
    tables.forEach(table => {

        // Check the corresponding radio buttons in all sections
        if(table.querySelectorAll('[name^=product-]').length) {
            table.querySelectorAll('[name^=product-]').forEach(radio => radio.checked = (radio.value === value));

            // Update selling plan
            const sellingPlan = target.dataset.sellingPlan;
            if(sellingPlan) {
                table.querySelectorAll('[name=selling_plan]')?.forEach(sp => sp.value = sellingPlan);
            } else {
                table.querySelectorAll('[name=selling_plan]')?.forEach(sp => sp.value = "");
            }

            const href = target.dataset.href;
            table.querySelectorAll('.js-cta')?.forEach(btn => btn.setAttribute('href', href))
        }

        // Hide/show text accordingly
        const toggeableText = table.querySelectorAll('.js-item-toggeable');
        if(toggeableText.length) {
            toggeableText.forEach(text => text.style.opacity = (value === "subscribe") ? "1" : "0");
        }

        // Update price
        const full_price = price.split('.');
        const dollars = full_price[0];
        const cents = full_price.length ? full_price[1] : 0;
        table.querySelector('.js-price').innerHTML = `$${dollars}${cents ? `<sup>.${cents}</sup>` : ''}`;
    })

}

document.querySelectorAll('.js-cta')?.forEach(btn => btn.addEventListener('click', event => {
    event.stopImmediatePropagation();
}))

$(document).ready(function() {
       
    $(".js-accordion-btn").on("click", function () {

        var container = $(this).closest(".js-accordion");
        var answer = container.find(".js-accordion-answer");
        var trigger = container.find(".js-accordion-close");
       
        $(".js-accordion")
            .not(container)
            .removeClass("expanded")
            .find(".js-accordion-answer").slideUp(200);

        $(".js-accordion")
            .not(container)
            .find(".js-accordion-close")
            .removeClass("accordion--open")
            .addClass("accordion--close");
        
        container.toggleClass("expanded");
        answer.slideToggle(200);

        trigger.toggleClass("accordion--open accordion--close");
    });


    // Script for Scroll Down (Buy Now Button)
    $(".js-smooth-scroll").on("click", function (event) {
        event.preventDefault();

        const href = $(this).attr('href');
        var offsetTop = document.querySelector('.js-section-top') ? document.querySelector('.js-section-top').offsetHeight : 0 ;

        $('html, body').animate({
            scrollTop: $(href).offset().top - offsetTop
        }, {
            duration: 500,
            step: function( now, fx ) {
                var newOffset =  $(href).offset().top - offsetTop;
                if(fx.end !== newOffset)
                    fx.end = newOffset;
            }
        });
    });

});

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

let refWrapper = document.querySelector('.references');
let refItems = document.querySelectorAll('.ref')
refItems.forEach(function (item, index, array) {
    let refItem = document.createElement('li')
    refItem.innerHTML = item.getAttribute('data-url');
    refWrapper.appendChild(refItem);
    item.innerText = ++index;
})

document.addEventListener('DOMContentLoaded', function () {

    let scrollpos = window.scrollY
    const header = document.querySelector(".section-top")
    if(header) {
        const header_height =  header.offsetHeight

        const add_class_on_scroll = () => header.classList.add("active")
        const remove_class_on_scroll = () => header.classList.remove("active")

        scrollpos = window.scrollY;

        if (scrollpos >= header_height) {
            add_class_on_scroll()
        } else {
            remove_class_on_scroll()
        }

        window.addEventListener('scroll', function() {
            scrollpos = window.scrollY;
            if (scrollpos >= header_height) {
                add_class_on_scroll()
            } else {
                remove_class_on_scroll()
            }

        });
    }


    const timers = document.querySelectorAll(".js-timer");
    const target = new Date().getTime() + 8 * 60 * 60 * 1000;
    const interval = setInterval(() => {
        update(timers, target, interval);
    }, 1000);

    if(timers.length) {
        update(timers, target, interval);
    }

});

function pad(num) {
    return num.toString().padStart(2, "0");
}

function renderCountdown(el, hours, minutes, seconds) {
    const [h10, h1] = pad(hours).split("");
    const [m10, m1] = pad(minutes).split("");
    const [s10, s1] = pad(seconds).split("");

    el.innerHTML = `
      <span class="countdown-row">
        <span class="countdown-section">
          <span class="countdown-amount"><span>${h10}</span><span>${h1}</span></span>
          <span class="countdown-period">Hours</span>
        </span>
        <span class="countdown-section">
          <span class="countdown-amount"><span>${m10}</span><span>${m1}</span></span>
          <span class="countdown-period">Minutes</span>
        </span>
        <span class="countdown-section">
          <span class="countdown-amount"><span>${s10}</span><span>${s1}</span></span>
          <span class="countdown-period">Seconds</span>
        </span>
      </span>`;
}

function update(timers, target, interval) {
    const now = new Date().getTime();
    const diff = target - now;

    let hours = 0, minutes = 0, seconds = 0;

    if (diff > 0) {
        hours = Math.floor(diff / (1000 * 60 * 60));
        minutes = Math.floor((diff / (1000 * 60)) % 60);
        seconds = Math.floor((diff / 1000) % 60);
    }

    timers.forEach(el => renderCountdown(el, hours, minutes, seconds));

    if (diff <= 0) clearInterval(interval);
}


//Play video
const iframeThumbnails = document.querySelectorAll('.js-iframe-thumb');
let videoPlayer;
iframeThumbnails?.forEach(iframeThumb => {
    iframeThumb.addEventListener('click', handleVideos);
})

function handleVideos(event) {
    event.preventDefault();

    const wrapper = event.target.closest('.js-video-wrapper');
    const video = wrapper.querySelector('.js-iframe-video');

    if(!video.getAttribute('src')) {
        video.setAttribute('src', video.getAttribute('data-src'));

        event.target.remove();
    }
}

// ----------------------------------------------------------------------------------------
// #SCROLL TO TOP BUTTON
// ----------------------------------------------------------------------------------------

let scrollButton = document.querySelector('.js-scroll-top');

document.addEventListener("scroll", () => {
    if(!scrollButton) return;
    if (window.scrollY > 1000) {
        scrollButton.classList.add('active');
    } else {
        scrollButton.classList.remove('active');
    }
});

scrollButton?.addEventListener('click', function (e) {
    e.preventDefault();

    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});

// ----------------------------------------------------------------------------------------
// #SMOOTH SCROLLING WITH LAZYLOADED IMAGES
// ----------------------------------------------------------------------------------------

const header = document.querySelector('.header');
const headerHeight = header ? header.offsetHeight : 0;

function smoothScrollToTarget(target, duration = 800) {
    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    const start = window.scrollY;
    const distance = targetPosition - start;
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        window.scrollTo(0, start + distance * progress);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

// ----------------------------------------------------------------------------------------
// #DESKTOP MENU SCROLL
// ----------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {

    const desktopLinks = document.querySelectorAll('.header__menu-item');

    desktopLinks?.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = link.getAttribute('href');
            if (!href) return;

            const hash = href.includes('#') ? href.substring(href.indexOf('#')) : null;
            if (!hash) return;

            const target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                smoothScrollToTarget(target, 800);
            }
        });
    });
});


// ----------------------------------------------------------------------------------------
// #SMOOTH SCROLL BUTTONS (.js-scroll-btn)
// ----------------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.js-scroll-btn')?.forEach(scrollToBtn => {
        scrollToBtn.addEventListener('click', e => {
            e.preventDefault();
            const href = scrollToBtn.getAttribute('href');
            if (!href) return;

            const hash = href.includes('#') ? href.substring(href.indexOf('#')) : null;
            if (!hash) return;

            const target = document.querySelector(hash);
            if (target) {
                smoothScrollToTarget(target, 700);
            }
        });
    });
});

// ----------------------------------------------------------------------------------------
// #FAQ ACCORDION
// ----------------------------------------------------------------------------------------

let animationInProgress = false;

let slideUp = (target, parent, duration = 300) => {
    if (target) {
        animationInProgress = true;
        target.style.height = target.offsetHeight + 'px';
        parent.style.pointerEvents = "none";

        window.setTimeout(() => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            target.style.height = 0;
        }, 100);
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;
        }, duration + 100);
    }
}

let slideDown = (target, parent, duration = 300) => {
    if (target) {
        animationInProgress = true;
        target.style.removeProperty('display');
        parent.style.pointerEvents = "none";
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;

        window.setTimeout(() => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.height = height + 'px';
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
        }, 100);
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;
        }, duration + 100);
    }
}

let slideToggle = (target, parent, duration = 300) => {
    if (target && !animationInProgress) {
        if (window.getComputedStyle(target).display === 'none') {
            return slideDown(target, parent, duration);
        } else {
            return slideUp(target, parent, duration);
        }
    }
}

// ----------------------------------------------------------------------------------------
// #FAQ CLICKING
// ----------------------------------------------------------------------------------------
let accordion = document.querySelectorAll('.js-faq-trigger');

if (accordion.length > 0) {

    accordion.forEach(function (item) {
        item.addEventListener('click', toggleItem);
    });

    const firstAccordion = accordion[0];
    firstAccordion.classList.add('active');
    slideDown(firstAccordion.querySelector('.js-faq-content'), firstAccordion);
}

function toggleItem(e) {
    e && e.preventDefault();

    const target = e.target;

    let item = target.closest('.js-faq-trigger')
    item.classList.toggle('active')
    slideToggle(item.querySelector('.js-faq-content'), item)

    for (let sibling of item.parentNode.children) {

        if (sibling !== item) {
            sibling.classList.remove('active');
            slideUp(sibling.querySelector('.js-faq-content'), sibling);
        }
    }
}

// ----------------------------------------------------------------------------------------
// #HIDE STICKY CTA ABOVE CTA SECTION
// ----------------------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function() {

    const sticky = document.querySelector(".js-sticky-button");
    const target = document.querySelector("#buy-now");
    const startLimitEl = document.querySelector('.js-sticky-start');

    if (!sticky || !target || !startLimitEl) return;

    function toggleSticky() {
        const targetRect = target.getBoundingClientRect();
        const startLimitRect = startLimitEl.getBoundingClientRect();

        const hasPassedStart = startLimitRect.top <= 0;
        const targetInView =
            targetRect.top < window.innerHeight &&
            targetRect.bottom > 0;

        if (!hasPassedStart || targetInView) {
            sticky.classList.remove('active');
        } else {
            sticky.classList.add('active');
        }
    }

    toggleSticky();
    window.addEventListener("scroll", toggleSticky);

    let windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
        if(windowWidth !== window.innerWidth) {
            toggleSticky();
        }
    })
});